import { render, staticRenderFns } from "./SubscriberIcon.vue?vue&type=template&id=2dbda9bc&scoped=true&"
import script from "./SubscriberIcon.vue?vue&type=script&lang=ts&"
export * from "./SubscriberIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriberIcon.vue?vue&type=style&index=0&id=2dbda9bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbda9bc",
  null
  
)

export default component.exports